import { ErroDaApi } from './api';

/**
 * As duas faixas de texto do modulo 01, e a diferenca entre elas importa.
 *
 * `NotaDeEscopo` nao e o aviso de demonstracao — que, alias, nao existe mais:
 * ele dizia que os NUMEROS eram inventados, e nenhuma tela do sistema mostra
 * numero inventado desde que a fixture foi aposentada. O que precisa ser dito
 * nestas telas e outra coisa: o que o sistema ainda NAO faz com o que esta
 * gravado. Papel e
 * permissao gravam certo e nao barram nada, porque a autorizacao depende da
 * autenticacao (F-04). Quem le a tela precisa saber disso antes de concluir que
 * o acesso esta controlado.
 *
 * Usa o azul de informacao, que e a unica coisa que esse azul pode ser: ele nao
 * e acao e nao e status de maquina (p.22).
 */
export function NotaDeEscopo({ titulo, detalhe }: { readonly titulo: string; readonly detalhe: string }) {
  return (
    <div
      role="status"
      className="flex flex-wrap items-baseline gap-x-2 gap-y-1 rounded-controle bg-informacao-fundo px-4 py-2"
    >
      <span className="txt-apoio font-semibold text-informacao-texto">{titulo}</span>
      <span className="txt-apoio text-tinta-secundaria">{detalhe}</span>
    </div>
  );
}

/**
 * A recusa do servidor, escrita como o manual pede: o que aconteceu e o que
 * fazer em seguida (regra 10 do checklist, p.25).
 *
 * As duas metades chegam prontas do backend — `{ erro, comoResolver }` — e
 * incluem as recusas do BANCO ja traduzidas: nome repetido, referencia a
 * cadastro de outra empresa, campo obrigatorio vazio. Reescrever a frase aqui
 * seria criar uma segunda versao da mesma mensagem, para divergir na primeira
 * mudanca.
 *
 * Sem ponto de exclamacao e sem emoji, como o manual manda em toda mensagem do
 * sistema.
 */
export function MensagemDeErro({ erro }: { readonly erro: unknown }) {
  if (!erro) return null;

  const daApi = erro instanceof ErroDaApi ? erro : null;
  const titulo = daApi?.message ?? 'Não foi possível concluir';
  const comoResolver =
    daApi?.comoResolver ?? 'Tente de novo; se continuar, avise o suporte com o horário em que aconteceu.';

  return (
    <div role="alert" className="bloco-rebaixado flex flex-col gap-1 p-3">
      <span className="txt-corpo text-tinta">{titulo}</span>
      <span className="txt-apoio text-tinta-secundaria">{comoResolver}</span>
    </div>
  );
}

/**
 * A situacao de um cadastro, com o ROTULO ESCRITO — nunca so a cor (regra 2).
 *
 * E deliberadamente um marcador discreto, e nao um `BadgeStatus`: aquele
 * componente e dos SEIS status de maquina, e emprestar as cores dele para
 * cadastro faria "Em uso" competir com "Operando" na mesma tela. Aqui a
 * informacao e binaria e quase sempre "Em uso"; o que precisa saltar e o
 * arquivado, e ele salta por ser o unico com contorno.
 */
/**
 * A situacao de uma PESSOA (decisao do dono de 24/09): "Ativa" ou
 * "Desativada", em todo lugar — governanca da empresa e administracao da
 * plataforma. Cadastro e papel continuam com "Em uso" e "Arquivado", abaixo.
 * Mesmo desenho: so a desativada ganha contorno, porque e ela que precisa
 * saltar.
 */
export function SituacaoDePessoa({ ativo }: { readonly ativo: boolean }) {
  if (ativo) return <span className="txt-corpo text-tinta-secundaria">Ativa</span>;
  return (
    <span className="inline-flex h-[var(--selo-altura)] items-center rounded-badge border border-borda px-2">
      <span className="txt-badge text-tinta">Desativada</span>
    </span>
  );
}

export function Situacao({ ativo }: { readonly ativo: boolean }) {
  if (ativo) return <span className="txt-corpo text-tinta-secundaria">Em uso</span>;
  return (
    <span className="inline-flex h-[var(--selo-altura)] items-center rounded-badge border border-borda px-2">
      <span className="txt-badge text-tinta">Arquivado</span>
    </span>
  );
}

/**
 * 0132 · A etiqueta do papel de posto parceiro (p.25: etiqueta é atributo,
 * neutra e de raio 8). Diz a quem concede que o acesso é de gente de fora.
 */
export function EtiquetaDeParceiro() {
  return (
    <span className="inline-flex h-[var(--selo-altura)] items-center rounded-etiqueta bg-rebaixada px-2">
      <span className="txt-selo text-tinta-lista">Posto parceiro</span>
    </span>
  );
}
